<template>
  <div>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i
            class="fa fa-area-chart"
            style="font-size: 62px; color: #d14d65"
          ></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compTransitionDocsWhy.text-engager')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i class="fa fa-exchange" style="font-size: 50px; color: #8a4869"></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compTransitionDocsWhy.text-partager')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i class="fa fa-tags" style="font-size: 62px; color: #5f548d"></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compTransitionDocsWhy.text-tenir-compte')"
          />
        </div>
      </div>
    </article>
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i
            class="fa fa-toggle-on"
            style="font-size: 52px; color: #3b589f"
          ></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compTransitionDocsWhy.text-faciliter')"
          />
        </div>
      </div>
    </article>

    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <i
            class="fa fa-puzzle-piece"
            style="font-size: 52px; color: #3b589f"
          ></i>
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <p
            style="text-align: justify"
            v-html="$t('compTransitionDocsWhy.text-contribuer')"
          />
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'WhyTransition1point5'
}
</script>

<style lang="css">
article {
  border: 0px;
}
</style>
